package com.narbase.letsgo.web.translations


val arabicMap = mapOf(
        "Current Staff" to "الطاقم الحالي",
        "Inactive Staff" to "الطاقم الغير مفعل",
        "Staff Management" to "إدارة الطاقم",
        "Add staff member" to "إضافه عضو طاقم جديد",
        "Edit staff member" to "تعديل عضو طاقم",
).mapKeys { it.key.lowercase() }